module.exports = __webpack_public_path__ + "logo2.png?425dd06dc06c1fc4e1723e1f2247eab4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.png
// module id = 16
// module chunks = 0